<template>
  <app-page>
    <div class="follow">
      <div class="qrcode">
        <img src="@/assets/images/about/follow_qrcode.png" alt="">
      </div>
      <p class="description">
        欢迎关注翡翠王朝，服务号jaadee321，有任何问题请留言！
      </p>
    </div>
  </app-page>
</template>

<script>
  import AppPage from '../layouts/Main';
    export default {
        name: 'contact',
        components: {
          AppPage
        },
        data() {
            return {

            }
        },
        computed: {
        },
        mounted() {
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped >
  .follow{
    min-height: 100vh;
    background-color: rgba(255,255,255,1);
  }
  .qrcode{
    padding: 0.4rem 0.37rem 0.2rem 0.37rem;
  }
  .description{
    text-align: left;
    padding: 0 0.37rem;
    font-size:0.2rem;
    color:rgba(29,29,29,1);
    line-height:0.28rem;
  }
</style>
